import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'rsuite';
import { get, size, groupBy, map } from 'lodash/fp';
import OrderItemName from '../OrderItemName';
import {
  StyledPickListNameRow,
  StyledCategoryNameRow,
  StyledCategoryItemsRow,
  StyledPanel,
  Notes,
  StyledItemName,
  StyledItemQuantity
} from './elements';

const OrderList = ({ picklistName, items, notes }) => {
  const itemsByCategory = groupBy('picklistCategoryId', items);
  return (
    <StyledPanel shaded>
      <Grid fluid>
        <StyledPickListNameRow>
          <Col xs={24}>{picklistName}</Col>
        </StyledPickListNameRow>
      </Grid>
      <Grid fluid>
        {map(categoryItems => {
          const itemsLength = size(categoryItems);
          const withBorderLength = Math.floor(itemsLength / 4) * 4;
          const category = get('0.categorySnapshot.name', categoryItems);
          return (
            <div key={`category-${category}`}>
              <StyledCategoryNameRow>
                <Col xs={24}>{category}</Col>
              </StyledCategoryNameRow>
              <StyledCategoryItemsRow>
                {categoryItems.map(
                  ({ id, quantity, itemSnapshot, inventorySnapshot }, i) => (
                    <Col
                      xs={6}
                      key={`orderItem-${id}`}
                      style={{
                        borderBottom:
                          itemsLength >= 4 && i < withBorderLength
                            ? '1px solid #ddd'
                            : 'none',
                        borderRight:
                          (i + 1) % 4 === 0 ? 'none' : '1px solid #ddd'
                      }}
                    >
                      <Grid fluid>
                        <Row>
                          <StyledItemName xs={22}>
                            <OrderItemName
                              itemName={itemSnapshot.name}
                              inventorySnapshot={inventorySnapshot}
                            />
                          </StyledItemName>
                          <StyledItemQuantity xs={2}>
                            {quantity}
                          </StyledItemQuantity>
                        </Row>
                      </Grid>
                    </Col>
                  )
                )}
              </StyledCategoryItemsRow>
            </div>
          );
        }, itemsByCategory)}
      </Grid>
      {notes && (
        <Notes>
          Notes: <br />
          {notes}
        </Notes>
      )}
    </StyledPanel>
  );
};

OrderList.propTypes = {
  picklistName: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  notes: PropTypes.string.isRequired
};

export default OrderList;
